// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"493":"bee57237","626":"bf1baab7"}[chunkId] + ".chunk.css";
};